import { ProductEnum } from '../../authentication/models/product.enum';
import { User } from '../../authentication/models/v1-api.interface';

export function canMoveMoneyWithoutAccount(
  user:
    | Pick<User, 'productIds' | 'disableAdvances' | 'disableWithdrawals'>
    | null
    | undefined,
): boolean {
  return (
    !!user &&
    (!!user.productIds?.includes(ProductEnum.Payment) ||
      (!!user.productIds?.includes(ProductEnum.Advance) &&
        !user.disableAdvances &&
        !user.disableWithdrawals))
  );
}
